import {
  ABOUT_YOU_URL,
  ABOUT_YOUR_LOAN_URL,
  LANDING_URL,
  YOUR_BOUNCE_BACK_LOAN_URL,
  REPAYMENT_HOLIDAY_ENTRY_URL,
  EXTEND_TERM_ENTRY_URL,
} from "App.const";
import { RepaymentOptionType } from "./indicativeRepaymentOptions";

export enum Menu {
  AboutYou = "About you",
  AboutYourLoan = "About your loan",
  YourBounceBackLoan = "Your bounce back loan",
  RequestRepaymentHoliday = "Repayment holiday",
  ExtendTerm = "Extend the term of your loan",
}

export type TreatmentOptions =
  | typeof Menu.RequestRepaymentHoliday
  | typeof Menu.ExtendTerm;

export const menuUrl = (menu: string) => {
  switch (menu) {
    case "About you":
      return ABOUT_YOU_URL;
    case "About your loan":
      return ABOUT_YOUR_LOAN_URL;
    case "Your bounce back loan":
      return YOUR_BOUNCE_BACK_LOAN_URL;
    case "Repayment holiday":
      return REPAYMENT_HOLIDAY_ENTRY_URL;
    case "Extend the term of your loan":
      return EXTEND_TERM_ENTRY_URL;
    default:
      return LANDING_URL;
  }
};

export const defaultMenu = () => [
  Menu.AboutYou,
  Menu.AboutYourLoan,
  Menu.YourBounceBackLoan,
  Menu.RequestRepaymentHoliday,
  Menu.ExtendTerm,
];
export const getMenu = (menu: Menu) => {
  switch (menu) {
    case Menu.RequestRepaymentHoliday:
      return [
        Menu.AboutYou,
        Menu.AboutYourLoan,
        Menu.YourBounceBackLoan,
        Menu.ExtendTerm,
      ];
    case Menu.ExtendTerm:
      return [
        Menu.AboutYou,
        Menu.AboutYourLoan,
        Menu.YourBounceBackLoan,
        Menu.RequestRepaymentHoliday,
      ];
    default:
      return defaultMenu();
  }
};

export const treatmentOptions = (value: RepaymentOptionType): string => {
  switch (value) {
    case RepaymentOptionType.CRHWithoutExtendTerm:
    case RepaymentOptionType.CRHExtendTerm:
      return "Request a capital repayment holiday";
    case RepaymentOptionType.CIRHWithoutExtendTerm:
    case RepaymentOptionType.CIRHExtendTerm:
      return "Request a capital and interest repayment holiday";
    case RepaymentOptionType.ExtendTerm:
      return "Extend your original term to 10 years";
    default:
      throw new Error(`Unknown Treatment Options ${value}`);
  }
};

export enum TreatmentOptionPayloadType {
  EXTEND_TERM = "extend_term",
  REQUEST_PAYMENT_HOLIDAY = "request_payment_holiday",
}

export const toTreatmentOptionPayloadType = (
  type: TreatmentOptions
): TreatmentOptionPayloadType => {
  switch (type) {
    case Menu.RequestRepaymentHoliday:
      return TreatmentOptionPayloadType.REQUEST_PAYMENT_HOLIDAY;
    case Menu.ExtendTerm:
      return TreatmentOptionPayloadType.EXTEND_TERM;
  }
};
